(function () {
  'use strict';

  function initializeProducts(root) {
    if (!root || root.dataset.hengeWinnerInitialized === 'true') return;
    root.dataset.hengeWinnerInitialized = 'true';

    var selectors = Array.prototype.slice.call(root.querySelectorAll('[data-henge-product-selector]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-henge-product-panel]'));
    var blocks = Array.prototype.slice.call(root.querySelectorAll('[data-henge-product-target]'));
    var tabSelectors = Array.prototype.slice.call(root.querySelectorAll('[data-henge-tab-selector]'));
    var tabPanels = Array.prototype.slice.call(root.querySelectorAll('[data-henge-tab-panel]'));
    var desktopTabsMedia = window.matchMedia('(min-width: 750px)');
    var sticky = root.querySelector('[data-henge-sticky-cta]');
    var stickyImage = sticky && sticky.querySelector('[data-henge-sticky-image]');
    var stickyName = sticky && sticky.querySelector('[data-henge-sticky-name]');
    var stickyPrice = sticky && sticky.querySelector('[data-henge-sticky-price]');
    var stickyButton = sticky && sticky.querySelector('[data-henge-cta-position="sticky"]');
    var activeKey = 'clear';
    var showAllProducts = root.dataset.showAllProducts === 'true';
    var activeTab = 'detail';
    var activePanel = null;
    var detailObserver = null;
    var statusTimer = null;
    var purchaseStartTimer = null;
    var purchaseRequestPending = false;

    function dispatchAnalyticsEvent(name, detail) {
      try {
        root.dispatchEvent(new CustomEvent(name, {
          bubbles: true,
          detail: detail || {}
        }));
      } catch (error) {}
    }

    function parseOptionalDate(value) {
      if (!value) return null;
      var timestamp = Date.parse(value);
      return Number.isFinite(timestamp) ? timestamp : null;
    }

    function routesRoot() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    }

    function setPurchaseMessage(message) {
      var node = root.querySelector('[data-henge-demo-message]');
      if (!node) return;
      node.textContent = message || '';
      node.hidden = !message;
    }

    function getPurchaseErrorMessage(error) {
      if (typeof error === 'string' && error) return error;
      if (error && error.description) return error.description;
      if (error && error.message) return error.message;
      return 'カートに追加できませんでした。時間をおいて再度お試しください。';
    }

    function getPanelQuantity(panel) {
      if (!panel) return 1;
      var select = panel.querySelector('[data-henge-quantity-select]');
      if (select) return Math.max(1, parseInt(select.value, 10) || 1);
      var valueNode = panel.querySelector('[data-henge-quantity-value]');
      return Math.max(1, parseInt(valueNode && valueNode.textContent, 10) || 1);
    }

    function getPanelMaxQuantity(panel) {
      if (!panel) return 0;
      return Math.max(0, parseInt(panel.dataset.maxQuantity, 10) || 0);
    }

    async function getExistingCartQuantity(variantId) {
      var response = await fetch(routesRoot() + 'cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });

      var cart = await response.json();

      if (!response.ok) throw cart;

      return (cart.items || []).reduce(function (total, item) {
        if (String(item.variant_id) !== String(variantId)) return total;
        return total + (parseInt(item.quantity, 10) || 0);
      }, 0);
    }

    function openCartDrawer(product, variantId, button) {
      var form = document.createElement('form');
      var input = document.createElement('input');

      input.type = 'hidden';
      input.name = 'id';
      input.value = variantId;

      form.hidden = true;
      form.appendChild(input);
      document.body.appendChild(form);

      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: {
          product: product,
          addToCartBtn: button
        }
      }));

      window.setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:open'));
        form.remove();
      }, 120);
    }

    function setPurchaseLoading(panel, loading) {
      var detailButton = panel && panel.querySelector('[data-henge-cta-position="detail"]');

      [detailButton, stickyButton].forEach(function (button) {
        if (!button) return;

        button.classList.toggle('is-loading', loading);

        if (loading) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        } else {
          button.removeAttribute('aria-busy');
        }
      });
    }

    function updateQuantityControls(panel) {
      if (!panel) return;
      var select = panel.querySelector('[data-henge-quantity-select]');
      if (select) {
        var selectMax = Math.max(1, parseInt(panel.dataset.maxQuantity, 10) || select.options.length);
        select.value = String(Math.min(selectMax, Math.max(1, parseInt(select.value, 10) || 1)));
        return;
      }
      var quantity = panel.querySelector('[data-henge-quantity]');
      if (!quantity) return;
      var valueNode = quantity.querySelector('[data-henge-quantity-value]');
      var current = Math.max(1, parseInt(valueNode && valueNode.textContent, 10) || 1);
      var max = Math.max(0, parseInt(panel.dataset.maxQuantity, 10) || 0);
      if (max > 0 && current > max) current = max;
      if (valueNode && valueNode.textContent !== String(current)) valueNode.textContent = String(current);
      quantity.querySelectorAll('[data-henge-quantity-change]').forEach(function (button) {
        var change = parseInt(button.dataset.hengeQuantityChange, 10) || 0;
        button.disabled = change < 0 ? current <= 1 : max > 0 && current >= max;
      });
    }

    function refreshGiftQuantityStepper(container) {
      if (!container) return;
      var trigger = container.querySelector('[data-testid="gift-quantity"]');
      var stepper = container.querySelector('[data-henge-egift-quantity]');
      if (!trigger || !stepper) return;
      var valueNode = stepper.querySelector('[data-henge-egift-quantity-value]');
      var current = Math.max(1, parseInt(trigger.textContent, 10) || 1);
      var panel = container.closest('[data-henge-product-panel]');
      var panelMax = Math.max(1, parseInt(panel && panel.dataset.maxQuantity, 10) || 4);
      var max = panelMax;
      var options = container.querySelectorAll('[data-testid^="select-option-"]');
      if (options.length) max = Math.min(max, options.length);
      current = Math.min(container.hengeGiftQuantityTarget || current, max);
      if (valueNode && valueNode.textContent !== String(current)) valueNode.textContent = String(current);
      var decrement = stepper.querySelector('[data-henge-egift-quantity-change="-1"]');
      var increment = stepper.querySelector('[data-henge-egift-quantity-change="1"]');
      if (decrement) decrement.disabled = current <= 1;
      if (increment) increment.disabled = current >= max;
    }

    function changeGiftQuantity(container, change) {
      var trigger = container && container.querySelector('[data-testid="gift-quantity"]');
      if (!trigger) return;
      var current = Math.max(1, parseInt(trigger.textContent, 10) || 1);
      var panel = container.closest('[data-henge-product-panel]');
      var max = Math.max(1, parseInt(panel && panel.dataset.maxQuantity, 10) || 4);
      var options = container.querySelectorAll('[data-testid^="select-option-"]');
      if (options.length) max = Math.min(max, options.length);
      var base = container.hengeGiftQuantityTarget || current;
      var next = Math.min(max, Math.max(1, base + change));
      if (next === base) return;
      container.hengeGiftQuantityTarget = next;
      refreshGiftQuantityStepper(container);
      if (container.hengeGiftQuantityBusy) return;

      container.hengeGiftQuantityBusy = true;
      var frameCount = 0;
      var menuOpened = false;
      function settle() {
        var actual = Math.max(1, parseInt(trigger.textContent, 10) || 1);
        var target = container.hengeGiftQuantityTarget || actual;
        if (actual === target) {
          container.hengeGiftQuantityTarget = 0;
          container.hengeGiftQuantityBusy = false;
          refreshGiftQuantityStepper(container);
          return;
        }

        if (!menuOpened) {
          trigger.click();
          menuOpened = true;
          frameCount = 0;
          window.requestAnimationFrame(settle);
          return;
        }

        var option = container.querySelector('[data-testid="select-option-' + target + '"]');
        if (option) {
          option.click();
          menuOpened = false;
          frameCount = 0;
          waitForSelection(target);
          return;
        }

        frameCount += 1;
        if (frameCount < 30) {
          window.requestAnimationFrame(settle);
        } else {
          container.hengeGiftQuantityTarget = 0;
          container.hengeGiftQuantityBusy = false;
          refreshGiftQuantityStepper(container);
        }
      }

      function waitForSelection(selectedValue) {
        var actual = Math.max(1, parseInt(trigger.textContent, 10) || 1);
        if (actual === selectedValue) {
          frameCount = 0;
          window.requestAnimationFrame(settle);
          return;
        }
        frameCount += 1;
        if (frameCount < 30) {
          window.requestAnimationFrame(waitForSelection);
        } else {
          container.hengeGiftQuantityTarget = 0;
          container.hengeGiftQuantityBusy = false;
          refreshGiftQuantityStepper(container);
        }
      }

      window.requestAnimationFrame(settle);
    }

    function reorderGiftSenderAndQuantity(container) {
      if (!container) return;
      var form = container.querySelector('[data-testid="gift-form"]');
      var quantityTrigger = form && form.querySelector('[data-testid="gift-quantity"]');
      var quantityField = quantityTrigger && quantityTrigger.closest('.chakra-form-control');
      var senderInput = form && form.querySelector('[data-testid="gift-nickname"]');
      var senderField = senderInput && senderInput.closest('.chakra-form-control');
      if (!form || !quantityField || !senderField || quantityField === senderField) return;

      // Reorder only the two complete form fields. This keeps All in gift's inputs,
      // card selector, and React-owned values intact while moving quantity above sender.
      var ancestor = senderField.parentElement;
      // Include the form's immediate layout wrapper; All in gift nests the two
      // fields as sibling branches inside that wrapper.
      while (ancestor && ancestor !== form) {
        if (ancestor.contains(quantityField)) {
          var senderBranch = senderField;
          var quantityBranch = quantityField;
          while (senderBranch.parentElement && senderBranch.parentElement !== ancestor) senderBranch = senderBranch.parentElement;
          while (quantityBranch.parentElement && quantityBranch.parentElement !== ancestor) quantityBranch = quantityBranch.parentElement;
          if (senderBranch !== quantityBranch) {
            var siblings = Array.prototype.slice.call(ancestor.children);
            if (siblings.indexOf(quantityBranch) > siblings.indexOf(senderBranch)) {
              ancestor.insertBefore(quantityBranch, senderBranch);
            }
            return;
          }
        }
        ancestor = ancestor.parentElement;
      }
    }

    function getGiftValidationErrors(container) {
      var form = container && container.querySelector('[data-testid="gift-form"]');
      if (!form) return [];

      var errors = [];
      var sender = form.querySelector('[data-testid="gift-nickname"]');
      var message = form.querySelector('textarea[data-testid="gift-display-card-message"]');
      var cardSelected = Array.prototype.some.call(form.querySelectorAll('[data-testid="gift-display-card"]'), function (control) {
        var label = control.closest('label');
        var radio = label && label.querySelector('input[type="radio"]');
        return !!(radio && (radio.checked || label.hasAttribute('data-checked')));
      });

      if (!sender || !sender.value.trim()) errors.push('贈り主のお名前を入力してください。');
      if (!cardSelected) errors.push('メッセージカードを選択してください。');
      if (!message || !message.value.trim()) errors.push('メッセージを入力してください。');
      return errors;
    }

    function updateGiftValidationMessage(container, messages) {
      var form = container && container.querySelector('[data-testid="gift-form"]');
      if (!form) return;

      var box = form.querySelector('[data-henge-gift-validation-errors]');
      if (!messages.length) {
        if (box) box.hidden = true;
        return;
      }

      if (!box) {
        box = document.createElement('div');
        box.className = 'henge-winner-gift-validation-errors';
        box.setAttribute('data-henge-gift-validation-errors', '');
        box.setAttribute('role', 'alert');
        box.setAttribute('aria-live', 'assertive');
        var cancelButton = Array.prototype.find.call(form.querySelectorAll('button'), function (button) {
          return (button.textContent || '').replace(/\s+/g, ' ').trim() === 'ギフト設定をキャンセルする';
        });
        var actionGroup = cancelButton && cancelButton.parentElement;
        if (actionGroup && actionGroup.parentElement === form) form.insertBefore(box, actionGroup);
        else form.appendChild(box);
      }

      while (box.firstChild) box.removeChild(box.firstChild);
      var title = document.createElement('p');
      title.className = 'henge-winner-gift-validation-errors__title';
      title.textContent = '入力内容をご確認ください。';
      box.appendChild(title);
      var list = document.createElement('ul');
      messages.forEach(function (message) {
        var item = document.createElement('li');
        item.textContent = message;
        list.appendChild(item);
      });
      box.appendChild(list);
      box.hidden = false;
    }

    function normalizeGiftForm(container) {
      var form = container && container.querySelector('[data-testid="gift-form"]');
      if (!form) return;

      Array.prototype.forEach.call(form.querySelectorAll('.chakra-text'), function (node) {
        var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (text === '必須入力です') {
          node.classList.add('henge-winner-required-note');
          node.setAttribute('aria-hidden', 'true');
        } else if (text === 'メッセージを入力してください') {
          node.textContent = 'メッセージを入力してください※必須入力です';
        }
      });
    }

    function syncGiftValidation(container) {
      var form = container && container.querySelector('[data-testid="gift-form"]');
      if (!form) return;

      normalizeGiftForm(container);
      var eGiftSelected = container.querySelector('[data-testid="gift-radio-group"] input[type="radio"][value="eGift"]:checked');
      if (!eGiftSelected) return;

      var previewButton = Array.prototype.find.call(form.querySelectorAll('button'), function (button) {
        return (button.textContent || '').replace(/\s+/g, ' ').trim() === 'プレビュー';
      });
      if (previewButton) {
        previewButton.disabled = false;
        previewButton.removeAttribute('aria-disabled');
      }

      var panel = container.closest('[data-henge-product-panel]');
      var detailCta = panel && panel.querySelector('[data-henge-cta-position="detail"]');
      if (panel && detailCta) updatePurchaseState(panel);
      var canPurchase = !!(detailCta && detailCta.dataset.purchaseState === 'active' && !detailCta.disabled && !purchaseRequestPending);
      var checkoutButton = form.querySelector('#all-in-gift-checkout-button');
      if (checkoutButton) {
        checkoutButton.disabled = !canPurchase;
        checkoutButton.setAttribute('aria-disabled', canPurchase ? 'false' : 'true');
      }

      if (container.dataset.hengeGiftValidationBound === 'true') return;
      container.dataset.hengeGiftValidationBound = 'true';
      container.addEventListener('click', function (event) {
        var target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
        var button = target && target.closest ? target.closest('button') : null;
        var currentForm = container.querySelector('[data-testid="gift-form"]');
        if (!button || !currentForm || !currentForm.contains(button)) return;

        var label = (button.textContent || '').replace(/\s+/g, ' ').trim();
        var isPreview = label === 'プレビュー';
        var isCheckout = button.id === 'all-in-gift-checkout-button';
        if (!isPreview && !isCheckout) return;

        var errors = getGiftValidationErrors(container);
        updateGiftValidationMessage(container, errors);
        if (errors.length) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      }, true);

      function refreshErrorsAndButtons(event) {
        var currentForm = container.querySelector('[data-testid="gift-form"]');
        if (!event.target || !currentForm || !currentForm.contains(event.target)) return;
        normalizeGiftForm(container);
        var box = currentForm.querySelector('[data-henge-gift-validation-errors]');
        if (box && !box.hidden) updateGiftValidationMessage(container, getGiftValidationErrors(container));
        syncGiftValidation(container);
      }
      container.addEventListener('input', refreshErrorsAndButtons, true);
      container.addEventListener('change', refreshErrorsAndButtons, true);
    }

    function syncGiftWidgetLoading(container) {
      if (!container) return;
      var loading = container.nextElementSibling;
      if (!loading || !loading.hasAttribute('data-henge-gift-loading')) return;
      loading.hidden = hasGiftWidgetContent(container);
    }

    function syncGiftCardOptions(container) {
      if (!container) return;

      Array.prototype.forEach.call(container.querySelectorAll('[data-testid="gift-display-card"]'), function (control) {
        var label = control.closest('label');
        var input = label && label.querySelector('input[type="radio"]');
        var group = label && label.closest('.chakra-radio-group');
        if (!label || !input || !group) return;

        var option = label.parentElement;
        while (option && option !== group) {
          if (option.querySelector('img[src*="displayMessageCards"]')) break;
          option = option.parentElement;
        }
        if (!option || option === group) return;

        var image = option.querySelector('img[src*="displayMessageCards"]');
        option.classList.add('henge-winner-gift-card-option');
        option.setAttribute('data-henge-selected', input.checked || label.hasAttribute('data-checked') ? 'true' : 'false');
        label.classList.add('henge-winner-gift-card-radio');
        if (!input.getAttribute('aria-label')) {
          input.setAttribute('aria-label', image && image.alt ? image.alt : 'メッセージカードを選択');
        }
      });
    }

    function initializeGiftCardOptions(container) {
      if (!container) return;
      syncGiftCardOptions(container);
      syncGiftWidgetLoading(container);
      if (container.dataset.hengeGiftCardClickBound === 'true') return;

      container.dataset.hengeGiftCardClickBound = 'true';
      container.addEventListener('click', function (event) {
        var target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
        if (!target || !target.closest) return;

        syncGiftCardOptions(container);
        var option = target.closest('.henge-winner-gift-card-option');
        if (!option || !container.contains(option) || target.closest('.henge-winner-gift-card-radio')) return;
        if (target.closest('button, a, input, textarea, select, [contenteditable="true"]')) return;

        var input = option.querySelector('.henge-winner-gift-card-radio input[type="radio"]');
        if (!input || input.checked) return;
        input.click();
        window.requestAnimationFrame(function () { syncGiftCardOptions(container); });
      });
    }

    function initializeGiftQuantityStepper(container) {
      if (!container) return;
      syncGiftCardOptions(container);
      syncGiftWidgetLoading(container);
      var trigger = container.querySelector('[data-testid="gift-quantity"]');
      if (!trigger) return;
      var field = trigger.closest('[role="group"]');
      if (!field) return;
      trigger.classList.add('henge-winner-gift-quantity-native');
      trigger.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('tabindex', '-1');

      var stepper = field.querySelector('[data-henge-egift-quantity]');
      if (!stepper) {
        stepper = document.createElement('div');
        stepper.className = 'henge-winner-egift-quantity-stepper';
        stepper.setAttribute('role', 'group');
        stepper.setAttribute('aria-label', '商品の数量');
        stepper.setAttribute('data-henge-egift-quantity', '');
        stepper.innerHTML = '<button type="button" data-henge-egift-quantity-change="-1" aria-label="数量を1つ減らす">−</button><span data-henge-egift-quantity-value aria-live="polite">1</span><button type="button" data-henge-egift-quantity-change="1" aria-label="数量を1つ増やす">＋</button>';
        field.appendChild(stepper);
      }

      if (stepper.dataset.hengeQuantityBound !== 'true') {
        stepper.dataset.hengeQuantityBound = 'true';
        stepper.querySelectorAll('[data-henge-egift-quantity-change]').forEach(function (button) {
          button.addEventListener('click', function () {
            changeGiftQuantity(container, parseInt(button.dataset.hengeEgiftQuantityChange, 10) || 0);
          });
        });
      }
      refreshGiftQuantityStepper(container);
      reorderGiftSenderAndQuantity(container);
      syncGiftValidation(container);
    }

    root.querySelectorAll('.sns-gift-product-container').forEach(function (container) {
      initializeGiftCardOptions(container);
      initializeGiftQuantityStepper(container);
      if (container.dataset.hengeGiftQuantityObserver === 'true') return;
      container.dataset.hengeGiftQuantityObserver = 'true';
      var refreshScheduled = false;
      function nodeContainsGiftQuantity(node) {
        return node && node.nodeType === 1 && (
          node.matches('[data-testid="gift-quantity"]') ||
          !!node.querySelector('[data-testid="gift-quantity"]')
        );
      }
      function nodeContainsGiftWidget(node) {
        return node && node.nodeType === 1 && (
          node.matches('[data-testid="gift-radio-group"], [data-testid="gift-form"], [data-testid="gift-display-card"]') ||
          !!node.querySelector('[data-testid="gift-radio-group"], [data-testid="gift-form"], [data-testid="gift-display-card"]')
        );
      }
      var giftQuantityObserver = new MutationObserver(function (records) {
        var trigger = container.querySelector('[data-testid="gift-quantity"]');
        var stepper = container.querySelector('[data-henge-egift-quantity]');
        var giftForm = container.querySelector('[data-testid="gift-form"]');
        var giftRadioGroup = container.querySelector('[data-testid="gift-radio-group"]');
        var hasRelevantMutation = records.some(function (record) {
          var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (stepper && target && (target === stepper || stepper.contains(target))) return false;
          if (giftForm && target && (target === giftForm || giftForm.contains(target))) return true;
          if (giftRadioGroup && target && (target === giftRadioGroup || giftRadioGroup.contains(target))) return true;
          if (trigger && target && (target === trigger || trigger.contains(target))) return true;
          return Array.prototype.some.call(record.addedNodes, nodeContainsGiftQuantity) ||
            Array.prototype.some.call(record.removedNodes, nodeContainsGiftQuantity) ||
            Array.prototype.some.call(record.addedNodes, nodeContainsGiftWidget) ||
            Array.prototype.some.call(record.removedNodes, nodeContainsGiftWidget);
        });
        if (!hasRelevantMutation) return;
        if (refreshScheduled) return;
        refreshScheduled = true;
        window.requestAnimationFrame(function () {
          refreshScheduled = false;
          initializeGiftQuantityStepper(container);
          reorderGiftSenderAndQuantity(container);
        });
      });
      giftQuantityObserver.observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    });

    function updatePurchaseState(panel) {
      if (!panel) return;
      var configured = panel.dataset.productConfigured === 'true';
      var available = panel.dataset.productAvailable === 'true';
      var start = parseOptionalDate(panel.dataset.purchaseStart);
      var end = parseOptionalDate(panel.dataset.purchaseEnd);
      var now = Date.now();
      var state = 'active';
      var label = root.dataset.ctaActiveLabel || '購入する';

      if (!configured) {
        state = 'unconfigured';
        label = root.dataset.ctaUnconfiguredLabel || '商品未設定';
      } else if (start !== null && now < start) {
        state = 'before';
        label = root.dataset.ctaBeforeLabel || '購入開始前です';
      } else if (end !== null && now > end) {
        state = 'ended';
        label = root.dataset.ctaEndedLabel || '購入期間は終了しました';
      } else if (!available) {
        state = 'soldout';
        label = root.dataset.ctaSoldoutLabel || '在庫切れ';
      }

      var disabled = state !== 'active' || purchaseRequestPending;
      [panel.querySelector('[data-henge-cta-position="detail"]'), stickyButton].forEach(function (button) {
        if (!button) return;
        button.textContent = label;
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        button.dataset.purchaseState = state;
      });
      var availability = panel.querySelector('.henge-winner-demo__availability');
      if (availability) availability.textContent = disabled ? label : '購入可能';
      updateQuantityControls(panel);
    }

    function schedulePurchaseStartUpdate(panel) {
      if (purchaseStartTimer) {
        window.clearTimeout(purchaseStartTimer);
        purchaseStartTimer = null;
      }
      if (!panel) return;

      var start = parseOptionalDate(panel.dataset.purchaseStart);
      var remaining = start === null ? 0 : start - Date.now();
      if (remaining <= 0) return;

      purchaseStartTimer = window.setTimeout(function () {
        purchaseStartTimer = null;
        if (!root.isConnected || panel !== activePanel) return;
        updatePurchaseState(activePanel);
        schedulePurchaseStartUpdate(activePanel);
      }, Math.min(remaining, 2147483647));
    }

    function observeDetailCta(panel) {
      if (!sticky || !('IntersectionObserver' in window)) return;
      if (detailObserver) detailObserver.disconnect();
      var detailCta = panel && panel.querySelector('[data-henge-cta-position="detail"]');
      if (!detailCta) return;
      detailObserver = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-detail-cta-visible', entries[0].isIntersecting);
      }, { threshold: 0.65 });
      detailObserver.observe(detailCta);
    }

    function syncSticky(panel) {
      if (!sticky || !panel) return;
      if (stickyName) stickyName.textContent = panel.dataset.productName || '';
      if (stickyPrice) stickyPrice.textContent = panel.dataset.productPrice || '';
      if (stickyButton) stickyButton.textContent = panel.dataset.productCtaLabel || '';
      if (stickyImage) {
        var imageUrl = panel.dataset.productImage || '';
        stickyImage.hidden = !imageUrl;
        if (imageUrl) {
          stickyImage.src = imageUrl;
          stickyImage.alt = panel.dataset.productName || '';
        } else {
          stickyImage.removeAttribute('src');
          stickyImage.alt = '';
        }
      }
    }

    function updateBlocks() {
      blocks.forEach(function (block) {
        var target = block.dataset.hengeProductTarget;
        block.hidden = !showAllProducts && target !== 'all' && target !== activeKey;
      });
    }

    function syncTabPanels() {
      var showAllPanels = showAllProducts || desktopTabsMedia.matches;
      tabPanels.forEach(function (panel) {
        var selected = panel.dataset.hengeTabKey === activeTab;
        panel.hidden = showAllPanels ? false : !selected;
        panel.classList.toggle('is-switching', selected);
      });
    }

    function selectTab(tabKey, moveFocus) {
      var selectedTab = tabSelectors.find(function (tab) {
        return tab.dataset.hengeTabKey === tabKey;
      });
      if (!selectedTab) return;
      activeTab = tabKey;

      tabSelectors.forEach(function (tab) {
        var selected = tab === selectedTab;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });

      syncTabPanels();

      if (moveFocus) selectedTab.focus();
    }

    function selectProduct(key, shouldScroll) {
      activeKey = key;
      selectors.forEach(function (selector) {
        var selected = selector.dataset.hengeProductKey === key;
        selector.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      activePanel = null;
      panels.forEach(function (panel) {
        var selected = panel.dataset.hengeProductKey === key;
        panel.hidden = showAllProducts ? false : !selected;
        panel.classList.toggle('is-switching', selected);
        if (selected) activePanel = panel;
      });

      updateBlocks();

      document.querySelectorAll('[data-henge-storage-target]').forEach(function (guide) {
        var targets = (guide.dataset.hengeStorageTarget || '').split(/\s+/);
        var visible = showAllProducts || targets.indexOf(key) >= 0;
        var block = guide.closest('.custom__item');
        guide.hidden = !visible;
        if (block) block.hidden = !visible;
      });
      document.querySelectorAll('.custom-content').forEach(function (section) {
        var visibleGuides = Array.prototype.filter.call(section.querySelectorAll('.custom__item'), function (item) {
          var guide = item.matches('[data-henge-storage-target]')
            ? item
            : item.querySelector('[data-henge-storage-target]');
          return guide && !item.hidden && !guide.hidden;
        });
        section.classList.toggle('has-one-storage-guide', visibleGuides.length === 1);
        section.querySelectorAll('.custom__item.is-single-storage-guide').forEach(function (item) {
          item.classList.remove('is-single-storage-guide');
        });
        if (visibleGuides.length === 1) {
          visibleGuides[0].classList.add('is-single-storage-guide');
        }
      });

      syncSticky(activePanel);
      observeDetailCta(activePanel);
      updatePurchaseState(activePanel);
      schedulePurchaseStartUpdate(activePanel);

      if (shouldScroll && activePanel) {
        var detail = activePanel.querySelector('.henge-winner-demo__detail');
        if (detail) {
          window.requestAnimationFrame(function () {
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            detail.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          });
        }
      }
    }

    root.querySelectorAll('[data-henge-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-henge-gallery-track]');
      var mainImage = gallery.parentElement.querySelector('.product-showcase__main-image');
      var imageButtons = Array.prototype.slice.call(gallery.querySelectorAll('[data-henge-gallery-image-button]'));
      imageButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!mainImage) return;
          mainImage.src = button.dataset.hengeGallerySrc || '';
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.alt = button.dataset.hengeGalleryAlt || '';
          imageButtons.forEach(function (other) {
            var selected = other === button;
            other.classList.toggle('is-active', selected);
            other.setAttribute('aria-current', selected ? 'true' : 'false');
          });
        });
      });
      var next = gallery.querySelector('[data-henge-gallery-next]');
      if (next && track) {
        next.addEventListener('click', function () {
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: Math.max(120, track.clientWidth * 0.75), behavior: reducedMotion ? 'auto' : 'smooth' });
        });
      }
    });

    selectors.forEach(function (selector) {
      selector.addEventListener('click', function () {
        selectProduct(selector.dataset.hengeProductKey, true);
      });
    });

    tabSelectors.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        selectTab(tab.dataset.hengeTabKey, false);
      });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabSelectors.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabSelectors.length) % tabSelectors.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabSelectors.length - 1;
        else return;
        event.preventDefault();
        selectTab(tabSelectors[nextIndex].dataset.hengeTabKey, true);
      });
    });

    if (desktopTabsMedia.addEventListener) {
      desktopTabsMedia.addEventListener('change', syncTabPanels);
    } else {
      desktopTabsMedia.addListener(syncTabPanels);
    }

    root.addEventListener('shopify:block:select', function (event) {
      var selectedBlock = event.target.closest && event.target.closest('[data-henge-block-id]');
      if (!selectedBlock || !root.contains(selectedBlock)) {
        var blockId = event.detail && event.detail.blockId;
        selectedBlock = blocks.find(function (block) { return block.dataset.hengeBlockId === blockId; });
      }
      if (!selectedBlock) return;
      var productTarget = selectedBlock.dataset.hengeProductTarget;
      var tabTarget = selectedBlock.dataset.hengeTabTarget || 'detail';
      if (productTarget && productTarget !== 'all') selectProduct(productTarget, false);
      selectTab(tabTarget, false);
    });

    root.querySelectorAll('[data-henge-quantity-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        updatePurchaseState(select.closest('[data-henge-product-panel]'));
      });
    });

    root.querySelectorAll('[data-henge-quantity]').forEach(function (quantity) {
      var valueNode = quantity.querySelector('[data-henge-quantity-value]');
      quantity.querySelectorAll('[data-henge-quantity-change]').forEach(function (button) {
        button.addEventListener('click', function () {
          var current = Math.max(1, parseInt(valueNode.textContent, 10) || 1);
          var change = parseInt(button.dataset.hengeQuantityChange, 10) || 0;
          var panel = quantity.closest('[data-henge-product-panel]');
          var max = Math.max(0, parseInt(panel && panel.dataset.maxQuantity, 10) || 0);
          var next = Math.max(1, current + change);
          if (max > 0) next = Math.min(max, next);
          valueNode.textContent = String(next);
          updateQuantityControls(panel);
        });
      });
    });

    root.querySelectorAll('[data-henge-cta]').forEach(function (button) {
      button.addEventListener('click', async function (event) {
        event.preventDefault();

        if (purchaseRequestPending) return;

        var panel = button.dataset.hengeCtaPosition === 'detail'
          ? button.closest('[data-henge-product-panel]')
          : activePanel;

        if (!panel) return;

        updatePurchaseState(panel);

        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        var variantId = panel.dataset.productVariantId;
        var quantity = getPanelQuantity(panel);
        var maxQuantity = getPanelMaxQuantity(panel);

        if (!variantId) {
          setPurchaseMessage('購入対象商品が設定されていません。');
          return;
        }

        purchaseRequestPending = true;
        setPurchaseLoading(panel, true);
        setPurchaseMessage('');
        dispatchAnalyticsEvent('henge:winner:add-to-cart-attempt', {
          product_key: panel.dataset.hengeProductKey || '',
          variant_id: String(variantId),
          quantity: quantity,
          cta_location: button.dataset.hengeCtaPosition === 'sticky' ? 'sticky' : 'main'
        });

        try {
          if (maxQuantity > 0) {
            var existingQuantity = await getExistingCartQuantity(variantId);

            if (existingQuantity + quantity > maxQuantity) {
              throw {
                description:
                  'この商品の購入上限は' +
                  maxQuantity +
                  '本です。カート内の数量をご確認ください。'
              };
            }
          }

          var response = await fetch(routesRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              properties: maxQuantity > 0
                ? { _henge_purchase_limit: String(maxQuantity) }
                : {}
            })
          });

          var product = await response.json();

          if (!response.ok || product.status === 422) {
            throw product;
          }

          dispatchAnalyticsEvent('henge:winner:add-to-cart-success', {
            product_key: panel.dataset.hengeProductKey || '',
            variant_id: String(variantId),
            quantity: quantity,
            cta_location: button.dataset.hengeCtaPosition === 'sticky' ? 'sticky' : 'main'
          });
          openCartDrawer(product, variantId, button);
        } catch (error) {
          dispatchAnalyticsEvent('henge:winner:add-to-cart-error', {
            product_key: panel.dataset.hengeProductKey || '',
            variant_id: String(variantId),
            quantity: quantity,
            cta_location: button.dataset.hengeCtaPosition === 'sticky' ? 'sticky' : 'main',
            error_code: error && error.status ? String(error.status) : 'purchase_error'
          });
          setPurchaseMessage(getPurchaseErrorMessage(error));
        } finally {
          purchaseRequestPending = false;
          setPurchaseLoading(panel, false);

          updatePurchaseState(panel);

          if (activePanel && activePanel !== panel) {
            updatePurchaseState(activePanel);
          }
        }
      });
    });

    var initialSelector = selectors.find(function (selector) {
      return selector.getAttribute('aria-pressed') === 'true';
    });
    if (initialSelector) activeKey = initialSelector.dataset.hengeProductKey;
    selectProduct(activeKey, false);
    selectTab(activeTab, false);

    statusTimer = window.setInterval(function () {
      if (!root.isConnected) {
        window.clearInterval(statusTimer);
        if (purchaseStartTimer) window.clearTimeout(purchaseStartTimer);
        return;
      }
      updatePurchaseState(activePanel);
    }, 60000);

    function handleVisibilityChange() {
      if (!root.isConnected) {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        return;
      }
      if (!document.hidden) updatePurchaseState(activePanel);
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
  }

  function initializeCommon(root) {
    if (!root || root.dataset.hengeWinnerInitialized === 'true') return;
    root.dataset.hengeWinnerInitialized = 'true';
    root.querySelectorAll('[data-henge-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var answerId = button.getAttribute('aria-controls');
        var answer = answerId && document.getElementById(answerId);
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (answer) answer.hidden = expanded;
      });
    });
  }

  function initializeBoutiqueSelector(root) {
    if (!root || root.dataset.hengeSelectorInitialized === 'true') return;
    root.dataset.hengeSelectorInitialized = 'true';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-henge-product-selector]'));
    var visible = cards.filter(function (card) {
      var target = document.getElementById((card.getAttribute('href') || '').slice(1));
      var shown = !!target && target.offsetHeight > 0 && window.getComputedStyle(target).display !== 'none';
      card.hidden = !shown;
      return shown;
    });
    root.classList.toggle('is-single-choice', visible.length === 1);
    visible.forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        var href = card.getAttribute('href') || '';
        var target = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
        if (!target) return;
        event.preventDefault();
        visible.forEach(function (other) { other.setAttribute('aria-pressed', other === card ? 'true' : 'false'); });
        window.history.pushState(window.history.state, '', href);
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.requestAnimationFrame(function () {
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });
    });
  }

  function initializeWithin(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-henge-winner-products]')) initializeProducts(context);
    if (context.matches && context.matches('[data-henge-winner-common]')) initializeCommon(context);
    if (context.matches && context.matches('[data-henge-winner-selector]')) initializeBoutiqueSelector(context);
    context.querySelectorAll('[data-henge-winner-products]').forEach(initializeProducts);
    context.querySelectorAll('[data-henge-winner-common]').forEach(initializeCommon);
    context.querySelectorAll('[data-henge-winner-selector]').forEach(initializeBoutiqueSelector);
  }

  var giftWidgetRefreshTimer = null;
  var giftWidgetRefreshInFlight = false;
  var giftWidgetRefreshQueued = false;
  // Theme editor replaces the Liquid section on setting changes. Keep the app-owned
  // React mount alive when only Liquid/CSS settings changed, then place it in the new wrapper.
  var retainedGiftMounts = window.__hengeWinnerRetainedGiftMounts || {};
  window.__hengeWinnerRetainedGiftMounts = retainedGiftMounts;
  var giftMountConfigAttributes = [
    'data-product-variant-id',
    'data-original-color-enable',
    'data-font-color',
    'data-secondary-font-color',
    'data-primary-button-color',
    'data-primary-button-text-color',
    'data-secondary-button-color',
    'data-secondary-button-text-color',
    'data-header-text',
    'data-gift-radio-text',
    'data-e-gift-radio-text',
    'data-e-gift-description-text'
  ];

  function hasGiftWidgetContent(container) {
    return !!container.querySelector('[data-testid="gift-radio-group"]');
  }

  function getEditorSectionKey(event) {
    var section = event && event.target;
    var rawKey = event && event.detail && (event.detail.sectionId || event.detail.id);
    if (!rawKey && section) rawKey = section.getAttribute('data-section-id') || section.id;
    return rawKey ? String(rawKey).replace(/^shopify-section-/, '') : '';
  }

  function markGiftCardPreviewDialogs(scope) {
    if (!scope || scope.nodeType !== 1) return;
    var dialogs = [];
    if (scope.matches && scope.matches('.chakra-modal__content')) dialogs.push(scope);
    var closestDialog = scope.closest && scope.closest('.chakra-modal__content');
    if (closestDialog && dialogs.indexOf(closestDialog) === -1) dialogs.push(closestDialog);
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('.chakra-modal__content'), function (dialog) {
        if (dialogs.indexOf(dialog) === -1) dialogs.push(dialog);
      });
    }

    dialogs.forEach(function (dialog) {
      if (!dialog.querySelector('img[src*="displayMessageCards"]')) return;
      dialog.classList.add('henge-winner-gift-card-preview');
      dialog.querySelectorAll('p.chakra-text').forEach(function (paragraph) {
        var text = (paragraph.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        if (/^from(?:\s|$)/i.test(text)) {
          paragraph.classList.add('henge-winner-gift-card-preview-sender');
        } else {
          paragraph.classList.add('henge-winner-gift-card-preview-message');
        }
      });
    });
  }

  function markGiftResetDialogs(scope) {
    markGiftCardPreviewDialogs(scope);
    if (!scope) return;
    var resetButtons = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-testid="reset-button"]')) {
      resetButtons.push(scope);
    }
    if (scope.querySelectorAll) {
      resetButtons = resetButtons.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-testid="reset-button"]')));
    }
    resetButtons.forEach(function (button) {
      var dialog = button.closest('[role="dialog"]');
      if (dialog) dialog.classList.add('henge-winner-gift-reset-modal');
    });
  }

  function initializeGiftResetDialogObserver() {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', initializeGiftResetDialogObserver, { once: true });
      return;
    }
    if (window.__hengeWinnerGiftResetDialogObserver) return;

    markGiftResetDialogs(document.body);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, markGiftResetDialogs);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__hengeWinnerGiftResetDialogObserver = observer;
  }

  function retainGiftMountsBeforeSectionUnload(event) {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    var sectionKey = getEditorSectionKey(event);
    var section = event && event.target;
    if (!sectionKey || !section || !section.querySelectorAll) return;

    var mounts = Array.prototype.slice.call(section.querySelectorAll('.sns-gift-product-container'));
    var liveMounts = mounts.filter(hasGiftWidgetContent);
    if (liveMounts.length) retainedGiftMounts[sectionKey] = liveMounts;
  }

  function canReuseGiftMount(previousMount, replacementMount) {
    return giftMountConfigAttributes.every(function (attribute) {
      return previousMount.getAttribute(attribute) === replacementMount.getAttribute(attribute);
    });
  }

  function restoreGiftMountsAfterSectionLoad(event) {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    var sectionKey = getEditorSectionKey(event);
    var section = event && event.target;
    var retained = sectionKey && retainedGiftMounts[sectionKey];
    if (!section || !section.querySelectorAll || !retained) return;

    var replacements = Array.prototype.slice.call(section.querySelectorAll('.sns-gift-product-container'));
    replacements.forEach(function (replacement, index) {
      var previous = retained[index];
      if (!previous || hasGiftWidgetContent(replacement) || !canReuseGiftMount(previous, replacement)) return;
      replacement.replaceWith(previous);
    });
    delete retainedGiftMounts[sectionKey];
  }

  function scheduleGiftWidgetRefresh(scope) {
    if (!scope || !(window.Shopify && window.Shopify.designMode)) return;
    if (!scope.querySelector || !scope.querySelector('.sns-gift-product-container')) return;

    if (giftWidgetRefreshInFlight) {
      giftWidgetRefreshQueued = true;
      return;
    }

    window.clearTimeout(giftWidgetRefreshTimer);
    giftWidgetRefreshTimer = window.setTimeout(function () {
      var changedMounts = Array.prototype.slice.call(scope.querySelectorAll('.sns-gift-product-container'));
      var emptyMounts = changedMounts.filter(function (container) {
        return !hasGiftWidgetContent(container);
      });
      if (!emptyMounts.length) return;

      var appScript = Array.prototype.slice.call(document.scripts).find(function (script) {
        return !script.dataset.hengeGiftRefresh &&
          /gift-script|all.?in.?gift/i.test(script.src) &&
          /\/script\.js(?:\?|$)/i.test(script.src);
      });
      if (!appScript) return;

      giftWidgetRefreshInFlight = true;
      var temporarilyUnmatchedMounts = [];
      Array.prototype.slice.call(document.querySelectorAll('.sns-gift-product-container')).forEach(function (container) {
        if (emptyMounts.indexOf(container) !== -1 || !hasGiftWidgetContent(container)) return;
        temporarilyUnmatchedMounts.push(container);
        container.classList.remove('sns-gift-product-container');
      });

      var refreshScript = document.createElement('script');
      refreshScript.src = appScript.src;
      refreshScript.async = true;
      refreshScript.dataset.hengeGiftRefresh = 'true';

      var finished = false;
      function finishRefresh() {
        if (finished) return;
        finished = true;
        temporarilyUnmatchedMounts.forEach(function (container) {
          container.classList.add('sns-gift-product-container');
        });
        refreshScript.remove();
        giftWidgetRefreshInFlight = false;

        if (giftWidgetRefreshQueued) {
          giftWidgetRefreshQueued = false;
          scheduleGiftWidgetRefresh(document);
        }
      }

      refreshScript.addEventListener('load', finishRefresh, { once: true });
      refreshScript.addEventListener('error', finishRefresh, { once: true });
      window.setTimeout(finishRefresh, 4000);
      document.head.appendChild(refreshScript);
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  } else {
    initializeWithin(document);
  }
  initializeGiftResetDialogObserver();

  if (!window.__hengeWinnerSectionLoadBound) {
    window.__hengeWinnerSectionLoadBound = true;
    document.addEventListener('shopify:section:unload', retainGiftMountsBeforeSectionUnload);
    document.addEventListener('shopify:section:load', function (event) {
      restoreGiftMountsAfterSectionLoad(event);
      initializeWithin(event.target);
      scheduleGiftWidgetRefresh(event.target);
    });
  }
}());
